import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './page__content.scss';

const PageContent = ({ children, mix }) => <main className={cx('page__content', mix)}>{children}</main>;

PageContent.propTypes = {
    children: PropTypes.node,
    mix: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

export default PageContent;
